import styled from 'styled-components';

export const StyledActivtiesFilterModal = styled.div``;
